import f from "./index285.js";
import { createElementBlock as t, openBlock as o, createElementVNode as r, createCommentVNode as n, Fragment as u, renderList as m, normalizeClass as i, createTextVNode as b, toDisplayString as d, renderSlot as a } from "vue";
import p from "./index231.js";
const k = ["data-component"], h = { class: "relative flex justify-between" }, v = { class: "relative flex gap-32 overflow-x-scroll scrollbar-hide whitespace-nowrap pr-50" }, g = ["onClick"], $ = {
  key: 0,
  class: "hidden screen-l:flex"
}, y = {
  key: 0,
  id: "panel",
  class: "mt-16 screen-m:mt-24"
}, w = {
  key: 1,
  class: "flex mt-32 screen-l:hidden"
};
function C(e, s, _, z, x, N) {
  return o(), t("div", {
    "data-component": e.$options.name,
    class: "isolate"
  }, [
    r("div", h, [
      s[0] || (s[0] = r("div", { class: "absolute bottom-0 left-0 w-full h-1 bg-color-neutral-grey-10 rounded-normal z-content" }, null, -1)),
      s[1] || (s[1] = r("div", { class: "absolute right-0 h-full bottom-1 w-50 bg-gradient-to-l from-white z-content-linkarea screen-m:hidden" }, null, -1)),
      r("div", v, [
        (o(!0), t(u, null, m(e.options, (l, c) => (o(), t("button", {
          key: c,
          class: i(["relative pb-5 font-bold text-transparent cursor-pointer text-text-l-desktop group after:h-1 after:w-full after:absolute after:bottom-0 after:left-0 hover:after:bg-color-neutral-black focus:after:bg-color-neutral-black after:z-content-control after:rounded-normal", {
            "after:bg-color-neutral-black": e.isChecked(l)
          }]),
          type: "button",
          onClick: (V) => e.onClick(l)
        }, [
          b(d(l) + " ", 1),
          r("span", {
            class: i(["absolute inset-0 flex items-center justify-center font-[400] cursor-pointer text-color-neutral-black group-hover:font-bold group-focus:font-bold", {
              "!font-bold": e.isChecked(l)
            }])
          }, d(l), 3)
        ], 10, g))), 128))
      ]),
      e.$slots.link ? (o(), t("div", $, [
        a(e.$slots, "link")
      ])) : n("", !0)
    ]),
    e.$slots.default ? (o(), t("div", y, [
      a(e.$slots, "default")
    ])) : n("", !0),
    e.$slots.link ? (o(), t("div", w, [
      a(e.$slots, "link")
    ])) : n("", !0)
  ], 8, k);
}
const S = /* @__PURE__ */ p(f, [["render", C]]);
export {
  S as default
};
